import React, {useRef, useState} from "react"
import * as Yup from "yup"
import {useSelector} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"

// components
import {GenericButton} from "../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import Separator from "../../../components/Separator";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import ModalFormTitle from "../../../components/genericComponents/ModalFormTitle";

// labels
import {PH_NAME} from "../../../components/i18n/placeHolders"
import { LB_NAME, REQUIRED} from "../../../components/i18n/i18n"
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// services
import {paymentMethodService} from "../../../jwt/_services/configuration/paymentMethodService"

// utils
import {getStateByPath} from "../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";



const PaymentMethodForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { udn, editMode, domainObject} = componentState?.data;


    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().required( REQUIRED ),
    });


    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            name: domainObject?.name,
            xapiId: domainObject?.xapiId,
        }
    });


    const onSubmit = (data, _) => {
        let dataRequest = {
            item : {
                ...data,
            }
        };

        if (!editMode)
            genericIndexedActions.save(path, paymentMethodService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, paymentMethodService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }


    return <Form onSubmit={ handleSubmit(onSubmit) }>
        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />

                <div className={'top-right'}>
                    <GenericButton
                        style={'table'}
                        icon={'fa-save'}
                        toolTip={TT_SAVE}
                        permission={'add'}
                        type={'submit'}
                    />
                    {
                        editMode && <>
                            <GenericTableButton
                                toolTip={TT_HISTORY}
                                icon={'fa-clock'}
                                permission={'search'}
                                onClick={showHistory}
                            />
                        </>
                    }
                    <Separator/>
                    <GenericButton
                        style={'danger-secondary'}
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody className={'card-body-modal'}>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>{LB_NAME}</Label>
                            <Input
                                type="text"
                                name="name"
                                placeholder={PH_NAME}
                                innerRef={register}
                            />
                            {errors.name && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.name?.message}</div>}
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>XapiID</Label>
                            <Input
                                type="text"
                                name="xapiId"
                                placeholder={'Identificador de la Xapi'}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    </Form>
}
export default PaymentMethodForm